import { AssetUsageRecordStatus } from "../enums/asset-usage-record-status";

const hashTable = {
  [AssetUsageRecordStatus.Created]: "Новый",
  [AssetUsageRecordStatus.PreparedToSend]: "Подготовлен к отправке",
  [AssetUsageRecordStatus.PreparedToDelete]: "Подготовлен к удалению.",
  [AssetUsageRecordStatus.Expired]: "Просрочен",
  [AssetUsageRecordStatus.Sent]: "Отправлен в 1С",
  [AssetUsageRecordStatus.WrittenOff]: "Списан",
  [AssetUsageRecordStatus.Error]: "Ошибка",
  [AssetUsageRecordStatus.Deleted]: "Удален",
};

export function getTitleByStatus(status: AssetUsageRecordStatus): string {
  return hashTable[status];
}
